import React from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/graphic.scss';

const Graphic = ({ data }) => (
  <div className="graphic__custom" id={data.graphic}>
    <h5 className="graphic__hed benton-n6">{data.hed}</h5>
    <p className="graphic__chatter benton-n4">{data.chatter}</p>
    {/*
      Custom graphic code goes here, either inline or as an imported component.
      If multiple custome graphics per page, use a switch or if statements to target
      the correct component. Graphic specific legends would also go here or in the
      imported component file.
    */}
    <div className="graphic__footer">
      <p className="graphic__source bentonsanscond-n4">Source: {data.source}. {data.notes ? `Notes: ${data.notes}.` : null}</p>
      {data.credit ? <p className="graphic__credit bentonsanscond-n4">{data.credit}</p> : null}
    </div>
  </div>
);

export default Graphic;

Graphic.propTypes = {
  data: PropTypes.shape({
    graphic: PropTypes.string,
    hed: PropTypes.string,
    chatter: PropTypes.string,
    source: PropTypes.string,
    notes: PropTypes.string,
    credit: PropTypes.string,
  }).isRequired,
};
